import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "delivery",
  "use": "delivery-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"delivery\"><path d=\"M24 11a4.33 4.33 0 00-4.33-4.33h-3.34V4.79H0v12.5h3.06a2.88 2.88 0 005.43 0h5.11a2.88 2.88 0 005.43 0h5zM5.77 18.21a1.9 1.9 0 111.9-1.9 1.9 1.9 0 01-1.9 1.9zm7.65-1.92H8.67a2.9 2.9 0 00-5.79 0H1V5.79h14.33v7.81a2.88 2.88 0 00-1.91 2.69zm2.89 1.92a1.9 1.9 0 111.9-1.9 1.9 1.9 0 01-1.9 1.9zM23 16.29h-3.79a2.9 2.9 0 00-2.88-2.87V7.71h3.34A3.34 3.34 0 0123 11z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol